import { createFileRoute, redirect } from '@tanstack/react-router';
import { meQueryOptions, permissionSetFor } from '@/lib/me';
import { resolveFirstSetupPath, resolveLandingPath } from '@/lib/navigation';

// /setup → the first setup section the user can actually open. Hardcoding
// /setup/activities dead-ended anyone without activity.view on a NoAccess
// panel even when they could view another section. `me` is already cached by
// the _authenticated boundary, so this reads from cache.
export const Route = createFileRoute('/_authenticated/setup/')({
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(meQueryOptions);
    const permissions = permissionSetFor(me);
    throw redirect({
      to: resolveFirstSetupPath(permissions) ?? resolveLandingPath(permissions) ?? '/no-access',
    });
  },
});
